import type { VenueAccent } from '@/domains/shared/types/consts/pjazza/VenueAccent.consts.ts'

/**
 * The venue's accent as a wash over the card — a surface behind its own name, never a control.
 *
 * Mixed into the card rather than into transparency, so the wash is a card in its own right: in dark the
 * card is lifted off the black page, and a wash over transparency was the accent over black. How much
 * accent goes in is a token, because the dark card needs more of it for the hue to show.
 */
export const venueTintStyle = (accent: VenueAccent): { backgroundColor: string } => ({
  backgroundColor: `color-mix(in srgb, var(--pj-venue-${accent}) var(--pj-venue-wash), var(--pj-fill-card))`
})
